import React from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

import * as Text from 'theme/components/Text.style';
import * as Section from 'settings/styles/SettingsSection.style';

interface NotificationsLoadStateProps {
  hasFailed: boolean;
}

export default function NotificationsLoadState({
  hasFailed,
}: NotificationsLoadStateProps): JSX.Element {
  const { t } = useTranslation('pageSettings');

  return (
    <>
      <Section.SectionHeader>
        <Text.H5>{t('notifications.title')}</Text.H5>
      </Section.SectionHeader>
      <Section.LoadStateCard>
        {hasFailed ? (
          <Text.P2 role="alert">{t('notifications.loadError')}</Text.P2>
        ) : (
          <CircularProgress
            color="inherit"
            size={24}
            aria-label={t('notifications.loading')}
          />
        )}
      </Section.LoadStateCard>
    </>
  );
}
